export default __webpack_public_path__ + "static/media/catlow.68aa022f.jpg";